import {delay, isEmpty, template} from 'lodash';
import {buildHttpDocumentViewUrl, buildHttpUrl} from './ApiUtil';
import {RQ_DOCUMENT_THUMBNAIL_UI_API} from '@app/reactQuery/apis/constants';
import {AppConfig} from '@app/config';

export const navigateWithDelay = (navigate: any, route: string, delayTime: number = 1000): number => {
  return delay(() => {
    navigate(route);
  }, delayTime);
};

export const updateAppTitle = ({appName}: any): void => document.title = isEmpty(appName)
  ? AppConfig.DEFAULT_APP_NAME
  : appName;

export const updateFavicon = ({documentId = ''}: any = {}): void => {
  if (!isEmpty(documentId)) {
    let link: any = document.querySelector('link[rel~=\'icon\']');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = buildHttpDocumentViewUrl({
      url: buildHttpUrl(template(RQ_DOCUMENT_THUMBNAIL_UI_API.url)({id: documentId})),
    });
  }
};
